import { styled } from "@mui/material/styles";
import { Box, Stack, Container, Typography } from "@mui/material";

import Page from "../../components/Page";
import Logo from "../../components/Logo";

import { LoginForm } from "../../sections/auth/login";
import { useEffect, useState } from "react";

const RootStyle = styled("div")(({ theme }) => ({
  background: "#fff",
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: "100%",
  display: "flex",
  alignItems: "center",
  position: "absolute",
  padding: theme.spacing(3),
  justifyContent: "space-between",
  [theme.breakpoints.up("md")]: {
    alignItems: "flex-start",
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

export default function Login() {
  const [isLocal, setIsLocal] = useState(null);
  useEffect(() => {
    if (window.location.hostname.includes("woxa.com")) {
      window.location.href = "/sign-in";
    } else {
      setIsLocal(true);
    }
  }, []);

  if (isLocal === null || isLocal === false) return <div />;
  return (
    <Page title="Login">
      <RootStyle>
        <HeaderStyle>
          <Logo />
          {/* {smUp && (
            <Typography variant="body2" sx={{ mt: { md: -2 } }}>
              Don’t have an account? {''}
              <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
                Get started
              </Link>
            </Typography>
          )} */}
        </HeaderStyle>

        {/*{mdUp && (*/}
        {/*  <SectionStyle>*/}
        {/*    <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>*/}
        {/*      Hi, Welcome Back*/}
        {/*    </Typography>*/}
        {/*    <Image visibleByDefault disabledEffect src="/assets/illustrations/illustration_login.png" alt="login" />*/}
        {/*  </SectionStyle>*/}
        {/*)}*/}

        <Container maxWidth="sm">
          <ContentStyle>
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h4" gutterBottom>
                  Sign in to Woxa Partner
                </Typography>
              </Box>
              {/*<Tooltip title={capitalCase(method)} placement="right">*/}
              {/*  <>*/}
              {/*    <Image*/}
              {/*      disabledEffect*/}
              {/*      src={`https://minimal-assets-api-dev.vercel.app/assets/icons/auth/ic_${method}.png`}*/}
              {/*      sx={{ width: 32, height: 32 }}*/}
              {/*    />*/}
              {/*  </>*/}
              {/*</Tooltip>*/}
            </Stack>
            <LoginForm />
            {/* {!smUp && (
              <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                Don’t have an account?{' '}
                <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
                  Get started
                </Link>
              </Typography>
            )} */}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
